import React, { CSSProperties } from "react"
import Content from "./Content/Content"
import Section from "./Section/Section"
import Float from "./Float/Float"
import elementSplitter from "./utils/elementSplitter"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"

type WidgetCenterText = {
  children: React.ReactElement
  topSpace?: number | string
  topSpaceResponsive?: number | string
  width?: number
  backgroundType: BlurBackgroundProps["type"]
  style?: CSSProperties
}

const WidgetCenterText = ({
  children,
  topSpace = 100,
  topSpaceResponsive,
  width = 950,
  backgroundType,
  style = {},
}: WidgetCenterText) => {
  //
  const { headers, paragraphs, svgs, components } = elementSplitter(children)

  // Overlay SVG
  const decorativeSVG = svgs[0] && (
    <Float
      top={-100}
      left="50%"
      removeResponsive
      style={{ transform: "translateX(-50%)" }}
    >
      {svgs[0]}
    </Float>
  )

  return (
    <Content
      topSpace={topSpace}
      topSpaceResponsive={topSpaceResponsive}
      style={{ ...style, maxWidth: width }}
    >
      {decorativeSVG}

      <Section style={{ textAlign: "center" }}>
        {headers}
        {paragraphs}
        {components}
      </Section>

      {backgroundType && (
        <BlurBackground direction="center" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetCenterText
